export default __webpack_public_path__ + "static/media/018a.25bf3492.jpg";